<template>
  <div class="result">
    <div class="conTent">
      <!-- <el-date-picker
        class="data-picker"
        v-model="dataPickerYearVal"
        type="year"
        @change="dataPickerChange"
        :picker-options="pickerOptions"
        placeholder="选择年">
      </el-date-picker> -->
      <div class="conLeft">
        <span @click="openPicker"
          >{{ currentDate }}
          <i v-if="timePicker !== true"><van-icon name="arrow-down" /></i>
          <i v-else><van-icon name="arrow-up" /></i>
        </span>
        <van-popup
          v-model="timePicker"
          round
          get-container="body"
          position="bottom"
        >
          <van-picker
            show-toolbar
            title="选择年份"
            :default-index="defaultIndex"
            :columns="columns"
            @cancel="timePicker = false"
            @confirm="confirmDate"
          />
        </van-popup>
      </div>

      <div class="datail-statistical-title">
        明细统计-人
      </div>
      <div class="datail-statistical">
        <div
          class="statistical-item"
          @click="statisticalItemM(item)"
          v-for="(item, index) in statisticalList"
          :key="index">
          <div class="item-top">{{ item.num }}</div>
          <div class="item-bottom">{{ item.detail }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const lastYear = moment(new Date()).year();
const yearsList = [...new Array(10).keys()]
  .map((k) => {
    return `${lastYear - k}年`;
  })
  .reverse();
import moment from "moment";
import api from "@/apis";
export default {
  name: "result",
  data() {
    return {
      currentDate: (Number(moment(new Date()).year()) - 1) + "年", // 当前展示时间
      timePicker: false,
      columns: yearsList, //
      defaultIndex: 0,
      baseinfo:{},

      // pickerOptions: {
      //   disabledDate(time) {
      //     return time.getTime() > Date.now()
      //   }
      // },
      // dataPickerYearVal: moment(new Date()).format("YYYY"),
      statisticalList: [],
      salaryInfo: '',
    };
  },
  mounted() {
    this.salaryInfo = JSON.parse(localStorage.getItem("salaryInfo"));
    this.initData()
  },
  methods: {
    // 选择年份
    openPicker() {
      const currentIndex = yearsList.findIndex((item) => {
        return item === (this.currentDate || `${moment().year()}年`);
      });
      this.defaultIndex = currentIndex > -1 ? currentIndex : 0;
      this.timePicker = true;
    },
    // 回调参数: 多列：所有列选中值，所有列选中值对应的索引
    confirmDate(value) {
      this.currentDate = value;
      this.timePicker = false;
      this.initData()
    },
    initData() {
      api.selectDeptKpiListForGoup({
        empNo: this.salaryInfo.empNo,
        // empNo: '10003089',
        searchYear: parseInt(this.currentDate)
      }).then((res) => {
        this.statisticalList = [
          {
            num: res.data.snum || 0,
            detail: 'S(远超目标)',
          },
          {
            num: res.data.anum || 0,
            detail: 'A(超出目标)',
          },
          {
            num: res.data.bnum || 0,
            detail: 'B(达成目标)',
          },
          {
            num: res.data.cnum || 0,
            detail: 'C(部分达成目标)',
          },
          {
            num: res.data.dnum || 0,
            detail: 'D(未达成目标)',
          },
        ]
      })
    },
    // dataPickerChange(val) {
    //   this.dataPickerYearVal = moment(val).format("YYYY")
    //   this.initData()
    // },
    // 跳转详情
    statisticalItemM(item) {
      this.$router.push({
        path: '/mobile/statistical/detail',
        query: {
          dataPickerYearVal: parseInt(this.currentDate),
          salaryInfo: JSON.stringify(this.salaryInfo),
          item: JSON.stringify(item),
        }
      })
    }
  }
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
.conLeft {
  span {
    padding: 7px 18px;
    font-size: 12pt;
    color: #018755;
    border: 1px solid #018755;
    border-radius: 15px * $zoom;
  }
  p {
    font-size: 12pt;
    margin-top: 12px * $zoom;
  }
}
.result{
  font-size: 14px * $zoom;
  .conTent{
    width: 100%;
    background: #fff;
    padding: 15px * $zoom 10px * $zoom;
    border-radius: 10px * $zoom;
  }
  .data-picker {
    width: 180px;
  }
  .datail-statistical-title {
    margin-top: 20px * $zoom;
  }
  .datail-statistical {
    overflow: hidden;
    .statistical-item {
      float: left;
      width: 33%;
      height: 60px * $zoom;
      text-align: center;
      .item-top {
        margin-top: 20px * $zoom;
        font-size: 16px * $zoom;
      }
      .item-bottom {
        margin-top: 5px * $zoom;
        font-size: 8px * $zoom;
      }
    }
  }
}
</style>
